import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { useStore } from "@/hooks/useStore";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";
import TrainingVideosRepository from "@/utils/API/TrainingVideoRepository";
import VBreadcrumbs from "@/components/vBreadcrumbs.vue";
import VModal from "@/components/vModal.vue";
import CollapsableCardWithHeader from "@/components/bootstrap/CollapsableCardWithHeader.vue";

interface Video {
  id: number;
  name: string;
  categoryId: number;
  tutorialLink: string;
  description: string;
  youtubeLink: string;
}

interface Category {
  id: number;
  name: string;
  videos: Video[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingVideos',
  setup(__props) {

const categories = ref<Category[]>([]);
const defaultThumbnail = "/img/apple-profile.fd379455.jpg";
const store = useStore();
const viewMode = ref<'grid' | 'list'>('grid');

// Video Modal
const showYoutubeModal = ref(false);
const selectedYoutubeUrl = ref("");
const selectedYoutubeTitle = ref("");

const isSupademo = (link: string) => {
  return link && link.includes("supademo.com");
};

const getThumbnail = (video: Video) => {
  if (video.youtubeLink) {
    const match = video.youtubeLink.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
    );

    if (match) {
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    }
  }

  return defaultThumbnail;
};


function openYoutubeModal(video: Video) {
  if (!video.youtubeLink) return;

  selectedYoutubeUrl.value = video.youtubeLink;
  selectedYoutubeTitle.value = video.name;
  showYoutubeModal.value = true;
}

function closeYoutubeModal() {
  showYoutubeModal.value = false;
  selectedYoutubeUrl.value = "";
  selectedYoutubeTitle.value = "";
}

function getYoutubeEmbedUrl(url: string) {
  if (!url) return "";

  const patterns = [
    /(?:youtube\.com\/watch\?v=)([^&]+)/,
    /(?:youtu\.be\/)([^?&]+)/,
    /(?:youtube\.com\/shorts\/)([^?&]+)/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match?.[1]) {
      return `https://www.youtube.com/embed/${match[1]}?autoplay=1`;
    }
  }

  return "";
}

onMounted(async() => {
  const { data } = await TrainingVideosRepository.listCategories();
  const { data: videos } = await TrainingVideosRepository.listVideos();

  categories.value = data
    .sort((a: any, b: any) => a.sortOrder - b.sortOrder)
    .map((category: any) => ({
      ...category,
      videos: videos
        .filter((v: any) => v.categoryId === category.id)
        .sort((a: any, b: any) => a.sortOrder - b.sortOrder)
    }))
    .filter((category: any) => category.videos.length > 0);

  await store.value.dispatch(TRANSLATIONS_FETCH, {
    category: "pages",
    collections: ["common", "ingredients", "ingredient cost"],
  });
});


return { __sfc: true,categories, defaultThumbnail, store, viewMode, showYoutubeModal, selectedYoutubeUrl, selectedYoutubeTitle, isSupademo, getThumbnail, openYoutubeModal, closeYoutubeModal, getYoutubeEmbedUrl, VBreadcrumbs, VModal, CollapsableCardWithHeader }
}

})